import Link from "next/link";
import React from "react";
import Logo from "./Logo";
import Styled from "@emotion/styled";
import { Spacing } from "..";
import { useState } from "react";
import ContactDialog from "@components/contact-dialog";
import { useTranslations } from "next-intl";
import { useRemaxIntlNavLinks } from "shared/models/const/navsLink.const";
import { CPagesPath } from "shared/models/const/pages-path";
import FlatsSelector from "./flats";

const DesktopMenu = () => (
  <>
    <Logo />
    <Spacing />
    <NavLinksRender />
    <FlatsSelector />
  </>
);

export default DesktopMenu;

const NavLinksRender = () => {
  const [open, setOpen] = useState<boolean>(false);
  const translation = useTranslations("header");
  const paths = useRemaxIntlNavLinks();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ContainerLinks className="navbar_desktop__list_items">
        {paths.map((item, i) => {
          if (item.slug === translation("contact")) {
            return (
              <li key={i}>
                <ModalBtn onClick={handleOpen}>{item.slug}</ModalBtn>
              </li>
            );
          }

          return (
            <li key={i}>
              {!item?.target && (
                <Link href={item.link ?? ""} passHref>
                  <a className={getNavLinkClassName(item.link, item?.bold)}>
                    {item.slug}
                  </a>
                </Link>
              )}
              {item?.target && (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={getNavLinkClassName(item.link, item?.bold)}
                >
                  {item.slug}
                </a>
              )}
            </li>
          );
        })}
      </ContainerLinks>
      <ContactDialog
        open={open}
        onClose={handleClose}
        classNameModalButton="enviar-formulario-contacto-menu"
      />
    </>
  );
};

const getNavLinkClassName = (link?: string, bold?: boolean) => {
  const classes = [];

  if (bold) classes.push("bold");
  if (link === CPagesPath.es.join) classes.push("nav-pill", "nav-pill-agent");
  if (link === CPagesPath.es.franchises) {
    classes.push("nav-pill", "nav-pill-franchise");
  }

  return classes.join(" ");
};

const ContainerLinks = Styled.ul`
  list-style: none;
  display: flex;
  align-items: center;

  li{
   display: inline-block;
    margin-right: 18px;
    font-family: var(--font-family);
    font-size: 0.938rem;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0px;
    vertical-align: middle;
    a{
      color: black;
      transition: transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease;
    }
    a.bold{
      font-weight: bold;
    }

    a.nav-pill {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 38px;
      padding: 0.65rem 1.15rem;
      border-radius: 999px;
      color: var(--color-text-white);
      font-weight: 700;
      line-height: 1;
      white-space: nowrap;
      box-shadow: 0 12px 28px rgba(0, 0, 0, 0.16);
    }

    a.nav-pill:hover {
      transform: translateY(-1px);
      box-shadow: 0 16px 34px rgba(0, 0, 0, 0.2);
      opacity: 0.96;
    }

    a.nav-pill-agent {
      background-color: var(--color-brand-blue-main);
    }

    a.nav-pill-franchise {
      background-color: var(--color-brand-red-main);
    }
    
    @media screen and (max-width: 1000px) {
      font-size: 0.9rem;
      margin-right: 8px;

      a.nav-pill {
        min-height: 36px;
        padding: 0.6rem 0.9rem;
      }
    }
  }
`;

const ModalBtn = Styled.a`
  cursor: pointer;
`;

const FlagsContainer = Styled.div`
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    padding: 0 15px;
    margin-right: 5px;
    font-weight: 700;
    color: var(--color-brand-blue-main);
    display:flex;
    align-items: center;

    a {
      display: inline-block;
      margin-left: 15px;
    }
    img{
      width: 30px;
      vertical-align: middle;
    }

    .select-idiom{
      border: none;

    }

    @media screen and (max-width: 1000px) {
      padding: 0 10px;
      font-size: 14px;
    }
`;
